/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type CallControlsVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      createdAt: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
    }>
  } | null
}

export type FccJoinPassengerCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type FccJoinPassengerCallMutation = {
  __typename?: 'Mutation'
  fccJoinPassengerCall: any
}

export type CallPassengerButtonStartHandlingVehicleMutationVariables =
  Types.Exact<{
    vehicleId: Types.Scalars['ID']['input']
  }>

export type CallPassengerButtonStartHandlingVehicleMutation = {
  __typename?: 'Mutation'
  fccStartHandlingVehicle: any | null
}

export type FccInitiateOperatorToPassengerCallMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  emergencyStopAlertId?: Types.InputMaybe<Types.Scalars['ID']['input']>
}>

export type FccInitiateOperatorToPassengerCallMutation = {
  __typename?: 'Mutation'
  fccInitiateOperatorToPassengerCall: any
}

export type PhoneNumbersAssignedToVehicleQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type PhoneNumbersAssignedToVehicleQuery = {
  __typename?: 'Query'
  fccAllPhoneNumbersByVehicleId: Array<{
    __typename?: 'FccPhoneNumber'
    phoneNumber: string
    type: Types.FccPhoneNumberType
  }>
}

export const CallControlsVehicleFragmentDoc = gql`
    fragment CallControlsVehicle on Vehicle {
  id
  fccCurrentAdAlerts {
    alerts {
      id
      createdAt
      type
      status
    }
  }
}
    `
export const FccJoinPassengerCallDocument = gql`
    mutation FccJoinPassengerCall($vehicleId: ID!) {
  fccJoinPassengerCall(input: {vehicleId: $vehicleId})
}
    `
export type FccJoinPassengerCallMutationFn = Apollo.MutationFunction<
  FccJoinPassengerCallMutation,
  FccJoinPassengerCallMutationVariables
>

/**
 * __useFccJoinPassengerCallMutation__
 *
 * To run a mutation, you first call `useFccJoinPassengerCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccJoinPassengerCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccJoinPassengerCallMutation, { data, loading, error }] = useFccJoinPassengerCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useFccJoinPassengerCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccJoinPassengerCallMutation,
    FccJoinPassengerCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccJoinPassengerCallMutation,
    FccJoinPassengerCallMutationVariables
  >(FccJoinPassengerCallDocument, options)
}
export type FccJoinPassengerCallMutationHookResult = ReturnType<
  typeof useFccJoinPassengerCallMutation
>
export type FccJoinPassengerCallMutationResult =
  Apollo.MutationResult<FccJoinPassengerCallMutation>
export type FccJoinPassengerCallMutationOptions = Apollo.BaseMutationOptions<
  FccJoinPassengerCallMutation,
  FccJoinPassengerCallMutationVariables
>
export const CallPassengerButtonStartHandlingVehicleDocument = gql`
    mutation CallPassengerButtonStartHandlingVehicle($vehicleId: ID!) {
  fccStartHandlingVehicle(vehicleId: $vehicleId)
}
    `
export type CallPassengerButtonStartHandlingVehicleMutationFn =
  Apollo.MutationFunction<
    CallPassengerButtonStartHandlingVehicleMutation,
    CallPassengerButtonStartHandlingVehicleMutationVariables
  >

/**
 * __useCallPassengerButtonStartHandlingVehicleMutation__
 *
 * To run a mutation, you first call `useCallPassengerButtonStartHandlingVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallPassengerButtonStartHandlingVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callPassengerButtonStartHandlingVehicleMutation, { data, loading, error }] = useCallPassengerButtonStartHandlingVehicleMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useCallPassengerButtonStartHandlingVehicleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CallPassengerButtonStartHandlingVehicleMutation,
    CallPassengerButtonStartHandlingVehicleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CallPassengerButtonStartHandlingVehicleMutation,
    CallPassengerButtonStartHandlingVehicleMutationVariables
  >(CallPassengerButtonStartHandlingVehicleDocument, options)
}
export type CallPassengerButtonStartHandlingVehicleMutationHookResult =
  ReturnType<typeof useCallPassengerButtonStartHandlingVehicleMutation>
export type CallPassengerButtonStartHandlingVehicleMutationResult =
  Apollo.MutationResult<CallPassengerButtonStartHandlingVehicleMutation>
export type CallPassengerButtonStartHandlingVehicleMutationOptions =
  Apollo.BaseMutationOptions<
    CallPassengerButtonStartHandlingVehicleMutation,
    CallPassengerButtonStartHandlingVehicleMutationVariables
  >
export const FccInitiateOperatorToPassengerCallDocument = gql`
    mutation FccInitiateOperatorToPassengerCall($vehicleId: ID!, $emergencyStopAlertId: ID) {
  fccInitiateOperatorToPassengerCall(
    input: {vehicleId: $vehicleId, emergencyStopAlertId: $emergencyStopAlertId}
  )
}
    `
export type FccInitiateOperatorToPassengerCallMutationFn =
  Apollo.MutationFunction<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >

/**
 * __useFccInitiateOperatorToPassengerCallMutation__
 *
 * To run a mutation, you first call `useFccInitiateOperatorToPassengerCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccInitiateOperatorToPassengerCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccInitiateOperatorToPassengerCallMutation, { data, loading, error }] = useFccInitiateOperatorToPassengerCallMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      emergencyStopAlertId: // value for 'emergencyStopAlertId'
 *   },
 * });
 */
export function useFccInitiateOperatorToPassengerCallMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >(FccInitiateOperatorToPassengerCallDocument, options)
}
export type FccInitiateOperatorToPassengerCallMutationHookResult = ReturnType<
  typeof useFccInitiateOperatorToPassengerCallMutation
>
export type FccInitiateOperatorToPassengerCallMutationResult =
  Apollo.MutationResult<FccInitiateOperatorToPassengerCallMutation>
export type FccInitiateOperatorToPassengerCallMutationOptions =
  Apollo.BaseMutationOptions<
    FccInitiateOperatorToPassengerCallMutation,
    FccInitiateOperatorToPassengerCallMutationVariables
  >
export const PhoneNumbersAssignedToVehicleDocument = gql`
    query phoneNumbersAssignedToVehicle($vehicleId: ID!) {
  fccAllPhoneNumbersByVehicleId(vehicleId: $vehicleId) {
    phoneNumber
    type
  }
}
    `

/**
 * __usePhoneNumbersAssignedToVehicleQuery__
 *
 * To run a query within a React component, call `usePhoneNumbersAssignedToVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePhoneNumbersAssignedToVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePhoneNumbersAssignedToVehicleQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function usePhoneNumbersAssignedToVehicleQuery(
  baseOptions: Apollo.QueryHookOptions<
    PhoneNumbersAssignedToVehicleQuery,
    PhoneNumbersAssignedToVehicleQueryVariables
  > &
    (
      | {
          variables: PhoneNumbersAssignedToVehicleQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PhoneNumbersAssignedToVehicleQuery,
    PhoneNumbersAssignedToVehicleQueryVariables
  >(PhoneNumbersAssignedToVehicleDocument, options)
}
export function usePhoneNumbersAssignedToVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PhoneNumbersAssignedToVehicleQuery,
    PhoneNumbersAssignedToVehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PhoneNumbersAssignedToVehicleQuery,
    PhoneNumbersAssignedToVehicleQueryVariables
  >(PhoneNumbersAssignedToVehicleDocument, options)
}
export function usePhoneNumbersAssignedToVehicleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PhoneNumbersAssignedToVehicleQuery,
        PhoneNumbersAssignedToVehicleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PhoneNumbersAssignedToVehicleQuery,
    PhoneNumbersAssignedToVehicleQueryVariables
  >(PhoneNumbersAssignedToVehicleDocument, options)
}
export type PhoneNumbersAssignedToVehicleQueryHookResult = ReturnType<
  typeof usePhoneNumbersAssignedToVehicleQuery
>
export type PhoneNumbersAssignedToVehicleLazyQueryHookResult = ReturnType<
  typeof usePhoneNumbersAssignedToVehicleLazyQuery
>
export type PhoneNumbersAssignedToVehicleSuspenseQueryHookResult = ReturnType<
  typeof usePhoneNumbersAssignedToVehicleSuspenseQuery
>
export type PhoneNumbersAssignedToVehicleQueryResult = Apollo.QueryResult<
  PhoneNumbersAssignedToVehicleQuery,
  PhoneNumbersAssignedToVehicleQueryVariables
>
